module.exports = __webpack_public_path__ + "img/sup_deposit_bank_2.5a0270cc.png";